var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgBtc = function SvgBtc(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
    fill: "#F7931A"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M11.97 8.8c-.308 1.2-2.154.585-2.77.43l.523-2.092c.616.124 2.554.4 2.246 1.662Zm-.339 3.385c-.338 1.323-2.554.615-3.292.43l.584-2.307c.739.154 3.046.523 2.708 1.877ZM14.093 8.8c.184-1.292-.8-1.97-2.154-2.43l.43-1.724-1.076-.277-.431 1.693c-.277-.062-.585-.124-.862-.185l.431-1.692-1.077-.277-.43 1.723c-.247-.062-.462-.093-.678-.154l-1.476-.37-.277 1.14s.8.184.769.184c.43.092.523.4.492.615l-.492 1.97c.03 0 .061.03.123.03-.03 0-.062-.03-.123-.03l-.708 2.769c-.061.123-.184.338-.492.246l-.77-.185-.522 1.2 1.384.339c.246.061.523.123.77.184l-.431 1.754 1.077.277.43-1.723c.277.092.585.154.862.215l-.43 1.723 1.076.277.43-1.753c1.816.338 3.2.215 3.785-1.416.462-1.323-.03-2.061-.984-2.554.677-.184 1.2-.615 1.354-1.569Z",
    fill: "white"
  })));
};
export default SvgBtc;